import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { PageHeader } from '@/components/PageHeader';
import { EnterpriseAnalyticsEngine } from '@/components/EnterpriseAnalyticsEngine';
import { EnterpriseAuthentication } from '@/components/EnterpriseAuthentication';
import { AdvancedWorkflowManager } from '@/components/AdvancedWorkflowManager';
import { PerformanceOptimization } from '@/components/PerformanceOptimization';

const EnterpriseFeatures: React.FC = () => {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Enterprise Features"
        description="Phase 5: Advanced analytics, authentication & workflow automation"
      />

      <Tabs defaultValue="analytics" className="w-full">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="analytics">Analytics Engine</TabsTrigger>
          <TabsTrigger value="auth">Authentication</TabsTrigger>
          <TabsTrigger value="workflows">Workflows</TabsTrigger>
          <TabsTrigger value="performance">Performance</TabsTrigger>
        </TabsList>

        <TabsContent value="analytics" className="space-y-6">
          <EnterpriseAnalyticsEngine />
        </TabsContent>

        <TabsContent value="auth" className="space-y-6">
          <EnterpriseAuthentication />
        </TabsContent>

        <TabsContent value="workflows" className="space-y-6">
          <AdvancedWorkflowManager />
        </TabsContent>

        <TabsContent value="performance" className="space-y-6">
          <PerformanceOptimization />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default EnterpriseFeatures;